/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Switch as MantineSwitch, type MantineTheme, createTheme, rem } from '@mantine/core';

import { colorToken } from '@fai/design-tokens';

import * as classes from './switch.css';

export const switchTheme = createTheme({
  components: {
    Switch: MantineSwitch.extend({
      defaultProps: {
        size: 'sm',
      },
      vars: (_, props) => {
        if (props.size === 'sm') {
          return {
            root: {
              '--switch-thumb-size': rem(20),
              '--switch-height': rem(24),
              '--switch-width': rem(46),
            },
            track: {
              '--switch-disabled-color': props.checked
                ? colorToken.core.color.blue['200']
                : colorToken.core.color.grey['200'],
              '--switch-bd': 'none',
            },
            thumb: {
              '--switch-thumb-bd': 'none',
            },
          };
        }

        if (props.size === 'md') {
          return {
            root: {
              '--switch-thumb-size': rem(28),
              '--switch-height': rem(32),
              '--switch-width': rem(62),
              '--switch-bd': 'none',
            },
            track: {
              '--switch-disabled-color': props.checked
                ? colorToken.core.color.blue['200']
                : colorToken.core.color.grey['200'],
              '--switch-bd': 'none',
            },
            thumb: {
              '--switch-thumb-bd': 'none',
            },
          };
        }

        return {
          root: {},
        };
      },
      classNames() {
        return {
          thumb: classes.thumb,
        };
      },
    }),
  },
}) as MantineTheme;
